<template>
  <div>
    <v-row>
      <v-col>
        <v-select :items="departamentos" :disabled="pesquisando" label="Departamento" item-text="caminhoCompleto"
          item-value="id" v-model="params.departamentoID" required @change="carregarGrupos()" clearable></v-select>
      </v-col>
      <v-col>
         <v-select :items="grupos" :disabled="pesquisando" label="Grupo" item-text="nome" item-value="id"
          v-model="params.grupoID" required clearable></v-select>
      </v-col>
      <v-col>
        <v-select :items="periodos" :disabled="pesquisando" label="Período" v-model="params.periodo" required clearable></v-select>
      </v-col>
      <v-col>
        <v-switch v-model="params.listarApenasEmpresasVigentes">
          <template #label>Apenas Empresas Vigentes </template>
        </v-switch>
      </v-col>
      <v-col cols="2">
        <v-btn :disabled="(!params.departamentoID || !params.periodo) && pesquisando" @click="pesquisar" color="primary"
          large>Pesquisar</v-btn>
      </v-col>
    </v-row>
    <v-alert dense outlined type="info" v-if="dataUltimaAtualizacao">
      Última atualização em: {{ dataUltimaAtualizacao }}
    </v-alert>
    <v-divider></v-divider>
    <div v-if="falhaNaBusca">
      <v-alert dense outlined type="info">
        Falha ao caregar Dashboard, por favor atualize a pagina
        <v-btn @click="refresh" small color="primary"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-alert>
    </div>
    <div v-else>
      <v-row>
        <v-progress-linear v-if="loadScoreCardProgress" center :size="100" color="primary"
          indeterminate></v-progress-linear>
        <v-col v-for="card in scoreCards" :key="card.label">
          <ScoreCards v-if="!loadScoreCardProgress" :scoreCard="card"></ScoreCards>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-n8">
        <v-col class="d-flex justify-end">
          <span class="font-weight-bold mt-6 mr-5">Tipo de Gráfico</span>
          <v-radio-group
            v-model="typeChart"
            row
          >
            <v-radio
              label="Barra"
              value="bar"
            ></v-radio>
            <v-radio
              label="Pizza"
              value="pie"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <template v-if="typeChart == 'bar'">
        <v-row>
          <v-col>
            <v-progress-circular v-if="loadPendentesPorGrupo" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadPendentesPorGrupo" :chartdata="pendentesPorGrupo" title="Pendentes por Grupos" />
          </v-col>
          <v-col>
            <v-progress-circular v-if="loadPendentesPorEmpresa" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadPendentesPorEmpresa" :chartdata="pendentesPorEmpresa" title="Pendentes por Empresa" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-progress-circular v-if="loadPendentesPorDocumentos" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadPendentesPorDocumentos" :chartdata="pendentesPorDocumentos" title="Pendentes por Documento" />
          </v-col>
          <v-col>
            <v-progress-circular v-if="loadPendentesPorEmpresaStatus" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadPendentesPorEmpresaStatus" :chartdata="pendentesPorEmpresaStatus" title="Pendentes por Empresa x Status" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-progress-circular v-if="loadPeriodoPorStatus" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadPeriodoPorStatus" :chartdata="periodoPorStatus" title="Registros por Periodo x Status" />
          </v-col>
          <v-col>
            <v-progress-circular v-if="loadDepartamentoPorStatus" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadDepartamentoPorStatus" :chartdata="departamentoPorStatus" title="Departamentos x Status" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-progress-circular v-if="loadGrupoPorEntidade" indeterminate :size="100"
              color="primary"></v-progress-circular>
            <HorizontalBar v-if="!loadGrupoPorEntidade" :chartdata="grupoPorEntidade" title="Grupos x Entidades" />
          </v-col>
          <v-col>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row v-if="pendentesPorEmpresaPie.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorEmpresa" :chartdata="pendentesPorEmpresaPie" title="Pendentes por Empresa" />      
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorGrupoPie.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorGrupo" :chartdata="pendentesPorGrupoPie" title="Pendentes por Grupos" />
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorDocumentosPie.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorDocumentos" :chartdata="pendentesPorDocumentosPie" title="Pendentes por Documento" />
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorEmpresaStatusAprovado.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorEmpresaStatus" :chartdata="pendentesPorEmpresaStatusAprovado" title="Pendentes por Empresa x Status - (Aprovado)" />
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorEmpresaStatusReprovado.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorEmpresaStatus" :chartdata="pendentesPorEmpresaStatusReprovado" title="Pendentes por Empresa x Status - (Reprovado)" />
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorEmpresaStatusAguardandoValidacao.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorEmpresaStatus" :chartdata="pendentesPorEmpresaStatusAguardandoValidacao" title="Pendentes por Empresa x Status - (Aguardando Validação)" />          
          </v-col>
        </v-row>
        <v-row v-if="pendentesPorEmpresaStatusAguardandoArquivos.datasets.length">
          <v-col>
            <Doughnut v-if="!loadPendentesPorEmpresaStatus" :chartdata="pendentesPorEmpresaStatusAguardandoArquivos" title="Pendentes por Empresa x Status - (Aguardando Arquivos)" />            
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="periodoPorStatusAprovado.datasets.length">
            <Doughnut v-if="!loadPeriodoPorStatus" :chartdata="periodoPorStatusAprovado" title="Registros por Periodo x Status - (Aprovado)" />
          </v-col>
          <v-col v-if="periodoPorStatusReprovado.datasets.length">
            <Doughnut v-if="!loadPeriodoPorStatus" :chartdata="periodoPorStatusReprovado" title="Registros por Periodo x Status - (Reprovado)" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="periodoPorStatusAguardandoValidacao.datasets.length">
            <Doughnut v-if="!loadPeriodoPorStatus" :chartdata="periodoPorStatusAguardandoValidacao" title="Registros por Periodo x Status - (Aguardando Validação)" />
          </v-col>
          <v-col v-if="periodoPorStatusAguardandoArquivos.datasets.length">
            <Doughnut v-if="!loadPeriodoPorStatus" :chartdata="periodoPorStatusAguardandoArquivos" title="Registros por Periodo x Status - (Aguardando Arquivos)" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="departamentoPorStatusAprovado.datasets.length">
            <Doughnut v-if="!loadDepartamentoPorStatus" :chartdata="departamentoPorStatusAprovado" title="Departamentos x Status - (Aprovado)" />
          </v-col>
          <v-col v-if="departamentoPorStatusReprovado.datasets.length">
            <Doughnut v-if="!loadDepartamentoPorStatus" :chartdata="departamentoPorStatusReprovado" title="Departamentos x Status - (Reprovado)" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="departamentoPorStatusAguardandoValidacao.datasets.length">
            <Doughnut v-if="!loadDepartamentoPorStatus" :chartdata="departamentoPorStatusAguardandoValidacao" title="Departamentos x Status - (Aguardando Validação)" />
          </v-col>
          <v-col v-if="departamentoPorStatusAguardandoArquivos.datasets.length">
            <Doughnut v-if="!loadDepartamentoPorStatus" :chartdata="departamentoPorStatusAguardandoArquivos" title="Departamentos x Status - (Aguardando Arquivos)" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="grupoPorEntidadeVigentes.datasets.length">
            <Doughnut v-if="!loadGrupoPorEntidade" :chartdata="grupoPorEntidadeVigentes" title="Grupos x Entidades - (Vigente)" />
          </v-col>
          <v-col v-if="grupoPorEntidadeFinalizadas.datasets.length">
            <Doughnut v-if="!loadGrupoPorEntidade" :chartdata="grupoPorEntidadeFinalizadas" title="Grupos x Entidades - (Finalizada)" />
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import DashboardService from "@/common/services/http/dashboard.service";
import DepartamentoService from "@/common/services/http/departamento.service";
import GrupoService from "@/common/services/http/grupo.service";
import HorizontalBar from "@/views/components/Graficos/HorizontalBar.vue";
import Doughnut from "@/views/components/Graficos/Doughnut.vue";
import ScoreCards from "@/views/components/ScoreCards.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import SweetAlert from "@/common/services/sweetalert.service";
import moment from 'moment';

export default {
  data: () => ({
    loadPendentesPorEmpresa: false,
    loadPendentesPorDocumentos: false,
    loadPendentesPorGrupo: false,
    loadPendentesPorEmpresaStatus: false,
    loadScoreCardProgress: false,
    loadPeriodoPorStatus: false,
    loadDepartamentoPorStatus: false,
    loadGrupoPorEntidade: false,
    pesquisando: false,
    params: {
      departamentoID: null,
      grupoID: null,
      periodo: null,
      empresasID: null,
      listarApenasEmpresasVigentes: true,
    },
    periodos: [],
    falhaNaBusca: false,
    colors: {},
    colorsSecundary: {
      Aprovado: "",
    },
    grupos: [],
    scoreCards: [],
    departamentos: [],
    pendentesPorEmpresa: {},
    pendentesPorEmpresaPie: {},
    pendentesPorGrupo: {},
    pendentesPorGrupoPie: {},
    pendentesPorDocumentos: {},
    pendentesPorDocumentosPie: {},
    periodoPorStatus: {},
    periodoPorStatusAprovado: {},
    periodoPorStatusReprovado: {},
    periodoPorStatusAguardandoArquivos: {},
    periodoPorStatusAguardandoValidacao: {},
    departamentoPorStatus: {},
    departamentoPorStatusAprovado: {},
    departamentoPorStatusReprovado: {},
    departamentoPorStatusAguardandoArquivos: {},
    departamentoPorStatusAguardandoValidacao: {},
    pendentesPorEmpresaStatus: {},
    pendentesPorEmpresaStatusAprovado: {},
    pendentesPorEmpresaStatusReprovado: {},
    pendentesPorEmpresaStatusAguardandoValidacao: {},
    pendentesPorEmpresaStatusAguardandoArquivos: {},
    grupoPorEntidade: {},
    grupoPorEntidadeFinalizadas: {},
    grupoPorEntidadeVigentes: {},
    usuario: null,
    tipoUsuario: null,
    tipoAgrupamentoDashboard: {
      EMPRESA: 1,
      GRUPO: 2,
      DOCUMENTO: 3,
      EMPRESA_E_STATUS: 4,
      PERIODO_E_STATUS: 5,
    },
    cliente: {},
    dataUltimaAtualizacao: null,
    typeChart: 'bar'
  }),
  props: {
    options: Object,
  },
  components: {
    HorizontalBar,
    Doughnut,
    ScoreCards,
  },
  async mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));

    if (
      JSON.parse(window.localStorage.getItem("usuario")).usuario != undefined
    ) {
      this.tipoUsuario = JSON.parse(
        window.localStorage.getItem("usuario")
      ).usuario.tipoUsuario;
    }

    this.colorsSecundary["Aprovado"] = this.getRandomColor();
    this.colorsSecundary["Reprovado"] = this.getRandomColor();
    this.colorsSecundary["Aguardando Arquivos"] = this.getRandomColor();
    this.colorsSecundary["Aguardando Validação"] = this.getRandomColor();
    this.colorsSecundary["Inativo"] = this.getRandomColor();
    this.colorsSecundary["Vigente"] = this.getRandomColor();
    this.colorsSecundary["Finalizada"] = this.getRandomColor();

    await this.pesquisar();
  },
  methods: {
    width(length) {
      return length > 20 ? "100" : "";
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    substring(periodo, length = 60) {
      return periodo.map((x) =>
        x.length > length ? `${x.substring(0, (length - 5))}...` : x
      );
    },
    loadScoreCard(data) {
      try {
        this.scoreCards = data.scoreDashboards;
        this.loadScoreCardProgress = false;
      } catch (e) {
        this.loadScoreCardProgress = false;
      }
    },
    refresh() {
      this.$router.go(this.$router.currentRoute);
    },
    async pesquisar() {
      this.pesquisando = true;
      this.falhaNaBusca = false;
      this.loadPendentesPorEmpresa = true;
      this.loadPendentesPorDocumentos = true;
      this.loadPendentesPorGrupo = true;
      this.loadScoreCardProgress = true;
      this.loadPendentesPorEmpresaStatus = true;
      this.loadPeriodoPorStatus = true;
      this.loadDepartamentoPorStatus = true;
      this.loadGrupoPorEntidade = true;

      await this.carregarDepartamentos();
      await this.initChart();
      this.pesquisando = false;
    },
    async carregarDepartamentos() {
      let result;

      if (this.tipoUsuario === 4)
        result = await DepartamentoService.getDepartamentoByUsuarioID();
      else
        result = await DepartamentoService.getDepartamentoByClienteID(
          this.cliente.id
        );

      if (result.success) this.departamentos = result.data;
    },

    async carregarGrupos() {
      const result = await GrupoService.getGrupoByDepartamentoID(
        this.params.departamentoID
      );

      if (result.success) this.grupos = result.data;
    },
    carregarPeriodos(data) {
      if (data.periodos.length > 0) {
        this.periodos = data.periodos;
        data.periodos.forEach((x) => {
          this.colors[x] = this.getRandomColor();
        });
      }
    },
    carregarPendentesPorEmpresa(data) {
      try {
        this.pendentesPorEmpresa = {
          labels: this.substring(data.periodo),
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colors[x.label],
          })),
        };

        this.pendentesPorEmpresaPie = this.setDataPie(data);
        this.loadPendentesPorEmpresa = false;
      } catch (ex) {
        this.loadPendentesPorEmpresa = false;
      }
    },
    carregarPendentesPorGrupo(data) {
      try {
        this.pendentesPorGrupo = {
          labels: this.substring(data.periodo),
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colors[x.label],
          })),
        };

        this.pendentesPorGrupoPie = this.setDataPie(data);
        this.loadPendentesPorGrupo = false;
      } catch (ex) {
        this.loadPendentesPorGrupo = false;
      }
    },
    carregarPendentesPorDocumento(data) {
      try {
        this.pendentesPorDocumentos = {
          labels: this.substring(data.periodo),
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colors[x.label],
          })),
        };

        this.pendentesPorDocumentosPie = this.setDataPie(data);
        this.loadPendentesPorDocumentos = false;
      } catch (ex) {
        this.loadPendentesPorDocumentos = false;
      }
    },
    carregarPeriodoPorStatus(data) {
      try {
        this.periodoPorStatus = {
          labels: data.periodo,
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colorsSecundary[x.label],
          })),
        };

        let bgColors = [];
        for(let i=0; i < data.periodo.length; i++) {
          bgColors.push(this.getRandomColor());
        }

        this.periodoPorStatusAprovado = this.setStatusDataPie(data, 'Aprovado', bgColors);
        this.periodoPorStatusReprovado = this.setStatusDataPie(data, 'Reprovado', bgColors);
        this.periodoPorStatusAguardandoArquivos = this.setStatusDataPie(data, 'Aguardando Arquivos', bgColors);
        this.periodoPorStatusAguardandoValidacao = this.setStatusDataPie(data, 'Aguardando Validação', bgColors);

        this.loadPeriodoPorStatus = false;
      } catch (ex) {
        this.loadPeriodoPorStatus = false;
      }
    },

    carregarDepartamentoPorStatus(data) {
      try {
        this.departamentoPorStatus = {
          labels: data.periodo,
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colorsSecundary[x.label],
          })),
        };

        let bgColors = [];
        for(let i=0; i < data.periodo.length; i++) {
          bgColors.push(this.getRandomColor());
        }

        this.departamentoPorStatusAprovado = this.setStatusDataPie(data, 'Aprovado', bgColors);
        this.departamentoPorStatusReprovado = this.setStatusDataPie(data, 'Reprovado', bgColors);
        this.departamentoPorStatusAguardandoArquivos = this.setStatusDataPie(data, 'Aguardando Arquivos', bgColors);
        this.departamentoPorStatusAguardandoValidacao = this.setStatusDataPie(data, 'Aguardando Validação', bgColors);
        this.loadDepartamentoPorStatus = false;
      } catch (ex) {
        this.loadDepartamentoPorStatus = false;
      }
    },

    carregarGruposPorEntidades(data) {
      try {
        this.grupoPorEntidade = {
          labels: data.periodo,
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colorsSecundary[x.label],
          })),
        };

        let bgColors = [];
        for(let i=0; i < data.periodo.length; i++) {
          bgColors.push(this.getRandomColor());
        }

        this.grupoPorEntidadeVigentes = this.setStatusDataPie(data, 'Vigente', bgColors);
        this.grupoPorEntidadeFinalizadas = this.setStatusDataPie(data, 'Finalizada', bgColors);
        this.loadGrupoPorEntidade = false;
      } catch (ex) {
        this.loadGrupoPorEntidade = false;
      }
    },

    async carregarPendentesPorEmpresaStatus(data) {
      try {
        this.pendentesPorEmpresaStatus = {
          labels: this.substring(data.periodo),
          datasets: data.dataSet.map((x) => ({
            ...x,
            backgroundColor: this.colorsSecundary[x.label],
          })),
        };

        let bgColors = [];
        for(let i=0; i < data.periodo.length; i++) {
          bgColors.push(this.getRandomColor());
        }

        this.pendentesPorEmpresaStatusAprovado = this.setStatusDataPie(data, 'Aprovado', bgColors);
        this.pendentesPorEmpresaStatusReprovado = this.setStatusDataPie(data, 'Reprovado', bgColors);
        this.pendentesPorEmpresaStatusAguardandoArquivos = this.setStatusDataPie(data, 'Aguardando Arquivos', bgColors);
        this.pendentesPorEmpresaStatusAguardandoValidacao = this.setStatusDataPie(data, 'Aguardando Validação', bgColors);

        this.loadPendentesPorEmpresaStatus = false;
      } catch (ex) {
        this.loadPendentesPorEmpresaStatus = false;
      }
    },

    async carregarDash() {

      try {
        const result = await DashboardService.getDashboardGetPendencias(
          this.cliente.id,
          this.params
        );

        if (result.success) {
          this.loadScoreCard(result.data);
          this.carregarPeriodos(result.data);
          this.dataUltimaAtualizacao = result.data.dataUltimaAtualizacao ? moment(result.data.dataUltimaAtualizacao).add(-3, 'hours').format('DD/MM/YYYY HH:mm:ss') : null;

          result.data.graficos.forEach((x) => {
            switch (x.tipoDashboard) {
              case 1:
                this.carregarPendentesPorEmpresa(x.listaPendenciaDashboard);
                break;
              case 2:
                this.carregarPendentesPorGrupo(x.listaPendenciaDashboard);
                break;
              case 3:
                this.carregarPendentesPorDocumento(x.listaPendenciaDashboard);
                break;
              case 4:
                this.carregarPendentesPorEmpresaStatus(
                  x.listaPendenciaDashboard
                );
                break;
              case 5:
                this.carregarPeriodoPorStatus(x.listaPendenciaDashboard);
                break;
              case 6:
                this.carregarDepartamentoPorStatus(x.listaPendenciaDashboard);
                break;
              case 7:
                this.carregarGruposPorEntidades(x.listaPendenciaDashboard);
                break;
            }
          });
        } else {
          throw new Error("erro ao iniciar os graficos");
        }
      } catch (ex) {
        this.falhaNaBusca = true;
        this.loadPendentesPorEmpresa = false;
        this.loadPendentesPorDocumentos = false;
        this.loadPendentesPorGrupo = false;
        this.loadScoreCardProgress = false;
        this.loadPendentesPorEmpresaStatus = false;
        this.loadPeriodoPorStatus = false;
      }
    },
    async initChart() {
      await this.carregarDash();
    },
    setDataPie(data) {
      let values = [];
      let bgColors = [];
      for(let i=0; i < data.periodo.length; i++) {
        let total = 0;
        data.dataSet.map((x) => {
          total += x.data[i];
        })
        values.push(total);
        bgColors.push(this.getRandomColor());
      }

      return {
        labels: this.substring(data.periodo),
        datasets: [{
          data: values.map(x => x),
          backgroundColor: bgColors.map(x => x),
        }],
      };
    },
    setStatusDataPie(data, status, bgColors) {
      return {
        labels: this.substring(data.periodo, 35),
        datasets: data.dataSet.filter(f => f.label == status).map((x) => ({
          ...x,
          backgroundColor: bgColors,
        })),
      };
    }
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(
        Modulo.Dashboard,
        Permissoes.Visualizar
      )
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
